import styled from 'styled-components';
import Alert from '@material-ui/lab/Alert';
import { rgba } from 'polished';

// CONSTANTS
import { ROYAL_BLUE_2, MAIN_BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const LessChannelsAlertStyled = styled(Alert)`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 24px 16px;

  display: flex;
  justify-content: center;

  background-color: ${ROYAL_BLUE_2};
  box-shadow: 0px 4px 24px ${rgba(MAIN_BLACK, 0.25)};

  .MuiAlert-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    p {
      width: 100%;
      max-width: 250px;
      text-align: center;
    }
  }

  .MuiAlert-action {
    position: absolute;
    top: 0;
    right: 5px;

    .MuiIconButton-root {
      padding: 10px;
    }

    .MuiSvgIcon-root {
      font-size: 3.3rem;
    }
  }

  .learn-more__button {
    margin-top: 16px;
    height: 44px;
  }

  ${breakpoints.up('sm')} {
    padding: 10px 0 10px 24px;

    .MuiAlert-action {
      position: relative;
      right: 0;
      margin: 0;
      padding: 0;

      .MuiButton-root {
        padding: 0 1.6rem;
        background: none;
      }
    }

    .MuiAlert-message {
      flex-direction: row;

      p {
        flex: 1;
        max-width: none;
        text-align: left;
      }

      .learn-more__button {
        width: 160px;

        margin: 0;
      }
    }
  }

  ${breakpoints.up('md')} {
    .MuiAlert-icon {
      display: block;
      margin-top: auto;
      margin-bottom: auto;
      margin-right: 10px;
    }
  }
`;

const LessChannelsNotificationStyled = styled.div`
  position: fixed;
  bottom: calc(175px + 12px);
  left: 0;
  width: 100%;
  padding: 0 15px;
  z-index: 3;

  ${breakpoints.up('sm')} {
    bottom: calc(80px + 12px);
  }

  ${breakpoints.up('md')} {
    position: absolute;
    bottom: 0;
    padding: 0;
  }

  ${breakpoints.up('lg')} {
    max-width: calc(100% - 260px);
    left: 260px;
  }
`;

export default LessChannelsNotificationStyled;
